import React, { useEffect } from 'react'
import { Switch, Route, withRouter } from 'react-router'
import { connect } from 'react-redux'
import { getUserResources } from '../../redux/actions'

import ResourceCatalog from '../../components/resourceCatalog/ResourceCatalog'
import DashboardContainer from './dashboard/DashboardContainer'

const ResourceCatalogContainer: React.FC = (props: any) => {
  const { user, getUserResources, resourcesLoaded, resources, location } = props

  useEffect(() => {
    if (user && user.access_token && location.pathname === '/resource') {
      getUserResources(user.access_token)
    }
  }, [user, getUserResources, location])

  return (
    <div>
      <Switch>
        <Route exact path="/resource">
          {resourcesLoaded && <ResourceCatalog resources={resources} />}
        </Route>
        <Route path="/resource/:resourceId">
          <DashboardContainer />
        </Route>
      </Switch>
    </div>
  )
}

function mapStateToProps(state: any) {
  return {
    user: state.oidc.user,
    resourcesLoaded: state.userResources.resourcesLoaded,
    resources: state.userResources.resources,
  }
}

export default withRouter(
  connect(mapStateToProps, { getUserResources })(ResourceCatalogContainer)
)
